__turbopack_context__.v({
  "fromDayOneSection": "from-day-one-module__-Og9eq__fromDayOneSection",
  "growTimeline": "from-day-one-module__-Og9eq__growTimeline",
  "metric": "from-day-one-module__-Og9eq__metric",
  "metricLabel": "from-day-one-module__-Og9eq__metricLabel",
  "metricValue": "from-day-one-module__-Og9eq__metricValue",
  "metrics": "from-day-one-module__-Og9eq__metrics",
  "stageContent": "from-day-one-module__-Og9eq__stageContent",
  "stageFadeInSlide": "from-day-one-module__-Og9eq__stageFadeInSlide",
  "stageIcon": "from-day-one-module__-Og9eq__stageIcon",
  "valueStage": "from-day-one-module__-Og9eq__valueStage",
  "valueStages": "from-day-one-module__-Og9eq__valueStages",
});
